import { render } from "./ModalWorkers.vue?vue&type=template&id=774e73cf&lang=pug"
import script from "./ModalWorkers.vue?vue&type=script&lang=js"
export * from "./ModalWorkers.vue?vue&type=script&lang=js"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__